export default "__VITE_ASSET__CVqMVzjQ__"